import {useEffect} from "react";
const useDevAffiliateScript = (deps = []) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://wisecos.idevaffiliate.com/connect/stripe_ip.php";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, deps);
};
export default useDevAffiliateScript;
